<template>
  <v-flex xs6 sm5>
    <v-text-field
      v-model="amount"
      label="Valor do Boleto"
      persistent-hint
      single-line
      type="number"
      step="0.01"
      prefix="R$"
    ></v-text-field>
  </v-flex>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      storeAmount: "bills/filtersAmount"
    }),
    amount: {
      get() {
        return this.storeAmount;
      },
      set(newAmount) {
        this.$store.dispatch("bills/setAmount", newAmount);
      }
    }
  }
};
</script>